import { Pipe, PipeTransform } from '@angular/core';
import { ClientPaymentCategory } from '../models/client-wallet.model';

@Pipe({
  name: 'clientPaymentCategory'
})
export class ClientPaymentCategoryPipe implements PipeTransform {

  transform(value: ClientPaymentCategory | null | undefined): string {
    switch (value) {
      case ClientPaymentCategory.PREPAID:
        return 'Prepaid';
      case ClientPaymentCategory.POSTPAID:
        return 'Postpaid';
      default:
        return '-';
    }
  }
}
